<template>
	<v-divider
		:vertical="vertical"
	/>
</template>

<script>
export default {
	props: {
		vertical: {
			type: Boolean,
			default: false,
		},
	},
}
</script>
